var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "join" },
    [
      _c("booking-header-details", {
        ref: "subheader",
        on: {
          edit: function ($event) {
            return _vm.$emit("edit-query", $event)
          },
        },
      }),
      _vm._v(" "),
      !_vm.isTravelAgent
        ? _c(
            "div",
            {
              staticClass: "join-wrapper",
              attrs: { "data-component": "booking-fans-join-wrapper" },
            },
            [
              _c("div", { staticClass: "join-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "join-details",
                    class: { "--padding-top-lg": _vm.showColumns },
                  },
                  [
                    _c("div", { staticClass: "join-details-header" }, [
                      _vm._v("\n          " + _vm._s(_vm.title) + "\n        "),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "join-details-description",
                      domProps: { innerHTML: _vm._s(_vm.description) },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "join-details-ctas" },
                      [
                        _c("auth-activator", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var activate = ref.activate
                                  return [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "log-in",
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return activate(
                                              "login",
                                              $event.target
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.logInButtonLabel) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "sign-up",
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return activate(
                                              "registration",
                                              $event.target
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.signUpButtonLabel) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1817613175
                          ),
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.showCarousel
                  ? _c(
                      "div",
                      { staticClass: "join-privileges-carousel" },
                      [
                        _c("carousel", {
                          key: _vm.complimentaryPrivileges.length,
                          attrs: {
                            selector: ".carousel-wrapper",
                            variant: "complimentary-privileges",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var imageLoadedEvent = ref.imageLoadedEvent
                                  var canLoad = ref.canLoad
                                  return _c(
                                    "section",
                                    { staticClass: "carousel" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "carousel-wrapper" },
                                        _vm._l(
                                          _vm.complimentaryPrivileges,
                                          function (privilege, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: "privilege-" + index,
                                                staticClass: "slide",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "slide-content",
                                                  },
                                                  [
                                                    _c(
                                                      "picture",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "lazyload",
                                                            rawName:
                                                              "v-lazyload",
                                                            value: {
                                                              src: privilege.IconUrl,
                                                              set: [
                                                                {
                                                                  width: "480",
                                                                  height: "240",
                                                                  breakpoint:
                                                                    "xs",
                                                                },
                                                                {
                                                                  width: "800",
                                                                  height: "360",
                                                                  breakpoint:
                                                                    "md",
                                                                },
                                                              ],
                                                              fit: "crop",
                                                              align: "center",
                                                              updateCallback:
                                                                imageLoadedEvent,
                                                              canLoad: canLoad,
                                                            },
                                                            expression:
                                                              "{\n                      src: privilege.IconUrl,\n                      set: [\n                        { width: '480', height: '240', breakpoint: 'xs' },\n                        { width: '800', height: '360', breakpoint: 'md' },\n                      ],\n                      fit: 'crop',\n                      align: 'center',\n                      updateCallback: imageLoadedEvent,\n                      canLoad,\n                    }",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "image-wrapper",
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticClass: "image",
                                                          attrs: {
                                                            src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                                                            alt: privilege.Description,
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "slide-description",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              privilege.Description
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                },
                              },
                            ],
                            null,
                            false,
                            362270895
                          ),
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showColumns
                  ? _c(
                      "div",
                      { staticClass: "join-privileges-columns" },
                      _vm._l(
                        _vm.privilegesColumns,
                        function (column, columnIndex) {
                          return _c(
                            "div",
                            {
                              key: columnIndex,
                              staticClass: "join-privileges-columns__column",
                            },
                            _vm._l(column, function (item, itemIndex) {
                              return _c(
                                "div",
                                {
                                  key: itemIndex,
                                  staticClass: "join-privileges-columns__card",
                                },
                                [
                                  _c("img", {
                                    staticClass:
                                      "join-privileges-columns__card-image",
                                    attrs: {
                                      src: item.IconUrl,
                                      alt: item.Description,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "join-privileges-columns__card-title",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.Description) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        }
                      ),
                      0
                    )
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showAddOns ? _c("booking-add-ons") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }